var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlutter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 299,
    viewBox: "0 0 256 299",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M238.523 297.482H149.634L68.1523 216L112.597 171.556L238.523 297.482Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.48633 149.332L149.634 1.18359H238.523L45.9308 193.776L1.48633 149.332Z",
    fill: "#50E6FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M238.523 134.518L112.597 260.443L68.1523 215.999L149.634 134.518H238.523Z",
    fill: "#50E6FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.581 171.556L68.1387 216L112.582 260.442L157.025 215.998L112.581 171.556Z",
    fill: "#35C1F1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 218.597,
    y1: 322,
    x2: 121.656,
    y2: 225.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454,
    stopColor: "#0275CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#0472C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#076BBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    stopColor: "#0D63AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.907,
    stopColor: "#135895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#16538C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutter);
export default __webpack_public_path__ + "static/media/flutter.643a93c82cd15bbffd12a9ce33a79751.svg";
export { ForwardRef as ReactComponent };